import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[autoselect]',
    standalone: false
})
export class AutoSelectDirective {
  constructor(private host: ElementRef) {}

  ngAfterViewInit() {
    this.host.nativeElement.focus();
  }
}
